import React from 'react';
import {useQuery} from 'react-query';
import {IOfferWithRewards} from 'types/offers';
import {QUERY_KEYS} from '../../../../../../constants';
import {getOffer} from 'api/offers';
import ItemDetails from 'components/item-details';

const Details: React.FC<{itemId: string}> = ({itemId}) => {
  const {data: resultData = null, isFetching} = useQuery<IOfferWithRewards>(
    [QUERY_KEYS.OFFERS.OFFER, itemId],
    async () => {
      return await getOffer(itemId, {include_rewards: true, include_offer_details: true});
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: !!itemId
    }
  );
  return <ItemDetails loading={isFetching} data={resultData} showButton={false} />;
};

export default Details;
